export default "__VITE_ASSET__CbPx_OmV__"